import React from 'react';
import { Box,
        Container,
        Row,
        Column,
        FooterLink,
        FooterText,
        SubRow,
        SubColumn,
        Heading } from './styles';
import { Logo } from '../Icons/Logo';
import { FacebookIcon } from '../Icons/FacebookIcon'
import { InstagramIcon } from '../Icons/InstagramIcon';
import { WhatssapIcon } from '../Icons/WhatssapIcon';

export const Footer = () => {
    return(
        <Box>
            <Container>
                <Row>
                    <Column>
                        <Logo color={'#ffffff'} width={'60%'} height={'30%'} widthResponsive={'130px'} heightResponsive={'58px'}/>
                        <SubRow>
                            <FooterText>Somos una marca apasionada que se inspira en crear y llevar al mercado colombiano productos de alta calidad para el cuidado de la belleza.</FooterText>
                        </SubRow>
                        <SubRow>
                            <FooterLink href="https://wa.me/573218068913?text=Hola%2C%20me%20interesar%C3%ADa%20saber%20m%C3%A1s%20sobre%20el%20producto">
                                <WhatssapIcon fill={'#ffffff'} fillOver={'#F9BE84'} width={'25px'} height={'25px'} />
                            </FooterLink>
                            <FooterLink href="https://www.facebook.com/profile.php?id=100081301421482">
                                <FacebookIcon fill={'#ffffff'} fillOver={'#F9BE84'} width={'25px'} height={'25px'} />
                            </FooterLink>
                            <FooterLink href="https://www.instagram.com/koracosmetics1">
                                <InstagramIcon fill={'#ffffff'} fillOver={'#F9BE84'} width={'25px'} height={'25px'} />
                            </FooterLink>
                        </SubRow>
                    </Column>
                    <Column>
                        <Heading>CONTÁCTANOS</Heading>
                        <FooterLink href="mailto:cosmetickora@gmail.com">cosmetickora@gmail.com</FooterLink>
                        <FooterLink href="tel:3053943822">305 394 3822</FooterLink>
                        <FooterLink href="tel:3014010145">301 401 0145</FooterLink>
                        <FooterText>Medellín - Antioquia</FooterText>
                    </Column>
                    <Column>
                        <Heading>INFORMACIÓN</Heading>
                        <FooterLink href="/preguntas">Preguntas frecuentes</FooterLink>
                        <FooterLink href="#">Políticas de privacidad</FooterLink>
                        <FooterLink href="#">Términos y condiciones</FooterLink>
                    </Column>
                </Row>
            </Container>
        </Box>
    )
}